import { APP_PREFIX } from "./index";

export const SURVEYS_PAGE = `${APP_PREFIX}/surveys`;
export const ACCOUNT_SETTINGS_PAGE = `${APP_PREFIX}/account-settings`;
export const ACCOUNT_SETTINGS_TARIFF_PAGE = `${APP_PREFIX}/account-settings/plans`;
export const SETTINGS_PAGE = `${APP_PREFIX}/settings`;
export const CONTACTS_PAGE = `${APP_PREFIX}/contacts`;
export const LOGIN_PAGE = `${APP_PREFIX}/login`;
